module.exports = __webpack_public_path__ + "static/media/dirt.80096cf2.svg";